import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import RatingStars from "@/components/base/RatingStars";
import { dramas } from "@/mocks/dramas";

const ranked = [...dramas].sort((a, b) => b.rating - a.rating).slice(0, 6);

export default function RankingSection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="剧集口碑评分"
          title="观众打分榜 · 判断值不值得追"
          description="评分由站内观众在看完至少三分之一剧集后给出，已剔除异常刷分。分数越高，说明人物与制作越经得起推敲。"
        />

        <div className="mt-9 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {ranked.map((drama, index) => (
            <div
              key={drama.id}
              className={`flex flex-col gap-4 p-4 transition-colors hover:bg-background-100 md:flex-row md:items-center md:gap-6 md:p-5 ${
                index !== 0 ? "border-t border-background-200" : ""
              }`}
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  index < 3
                    ? "bg-accent-500 text-secondary-950"
                    : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>

              <div className="flex min-w-0 flex-1 items-center gap-4">
                <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={drama.cover}
                    alt={`短剧《${drama.title}》海报缩略图`}
                    title={`${drama.title} 剧集口碑评分`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0">
                  <Link
                    to={`/drama/${drama.id}`}
                    className="font-heading text-base font-semibold text-foreground-950 hover:text-primary-600"
                  >
                    {drama.title}
                  </Link>
                  <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                    <span>导演 {drama.director}</span>
                    <span className="text-background-400">·</span>
                    <span>编剧 {drama.screenwriter}</span>
                    <span className="text-background-400">·</span>
                    <span>共 {drama.episodes} 集</span>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4 md:w-64">
                <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-primary-500"
                    style={{ width: `${drama.rating * 10}%` }}
                  />
                </div>
                <div className="flex items-center gap-2">
                  <RatingStars rating={drama.rating} size="text-xs" />
                  <span className="font-heading text-base font-bold text-primary-600">
                    {drama.rating.toFixed(1)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}